export default __webpack_public_path__ + "static/media/shadowWoman.9d23394c.png";